enum PaymentStatus {
  unpaid = 'Unpaid',
  paid = 'Paid',
  denied = 'Denied',
  canceled = 'Canceled',
}
export default PaymentStatus;
